export const AUTO_HEIGHT_CLASS = 'g_autoHeight'
export const CONTRASTS = ['dark', 'light']
export const ALIGNMENTS = ['left', 'right', 'center']
export const POSITIONS = ['bottom']
export const POSITIONS_MOBILE = ['bottom', 'top']
